import { Link } from 'react-router-dom';

export default function Page() {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 text-center">
      <p className="font-display text-7xl text-makhe-primary">404</p>
      <h1 className="mt-4 font-display text-3xl">This page wandered off.</h1>
      <p className="mt-3 text-makhe-muted">
        The link may be broken, or the page may have moved.
      </p>
      <Link
        to="/feed"
        className="mt-8 inline-flex rounded-full bg-makhe-ink px-6 py-3 text-[11px] uppercase tracking-widest text-makhe-bg"
      >
        Back to the feed
      </Link>
    </section>
  );
}
